import { useTheme } from '@mui/material';

import { NewsMenuIcon } from '@frontend-libs/portal';

import { EmptyState } from '@frontend/components';

export interface NewsListEmptyProps {
  title: string;
  description: string;
}

export const NewsListEmpty = (props: NewsListEmptyProps) => {
  const theme = useTheme();

  return (
    <EmptyState
      icon={
        <NewsMenuIcon
          width={36}
          height={36}
          stroke={theme.palette.primary.main}
          filled={false}
        />
      }
      title={props.title}
      description={props.description}
    />
  );
};
